import styles from './ProjectCandidatesCell.module.scss';

export const PROJECT_CANDIDATES_TOOLTIP_SKELETON_DATA_TEST_ID =
  'project-candidates-tooltip-skeleton';

const SKELETON_ROWS = [
  { key: 'first', width: '72px', hasDetail: false },
  { key: 'second', width: '96px', hasDetail: true },
  { key: 'third', width: '64px', hasDetail: false },
];

const ProjectCandidatesTooltipSkeleton = () => (
  <div
    aria-busy
    className={styles.skeleton}
    data-testid={PROJECT_CANDIDATES_TOOLTIP_SKELETON_DATA_TEST_ID}
  >
    {SKELETON_ROWS.map(skeletonRow => (
      <div className={styles.skeletonRow} key={skeletonRow.key}>
        <div className={styles.skeletonStage}>
          <span className={styles.skeletonChip} />
          <span
            className={styles.skeletonBar}
            style={{ width: skeletonRow.width }}
          />
          <span className={styles.skeletonCount} />
        </div>
        {skeletonRow.hasDetail && <span className={styles.skeletonDetail} />}
      </div>
    ))}
    <span className={styles.tooltipSubtitle}>Loading stage breakdown…</span>
  </div>
);

export default ProjectCandidatesTooltipSkeleton;
